export default {
    // --------Title--------
    properties: 'Properties',
    detailOfTheInjectionProps: 'Detail of the injection props',

    // --------MUI--------
    mainProperty: 'Main Property',
    module: 'Module',
    reference: 'Reference',
    fieldType: 'Field Type',
    propKey: 'Prop Key',
    isMultiple: 'Is Multiple',
    usedNo: 'Used No.',
    browseProps: 'Browse Props',

    singleValue: 'Single Value',
    moduleReference: 'Module Reference',
    moduleType: 'Module Type',
    refFieldValue: 'Ref Field Value',
    propValue: 'Prop Value',

};